var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full px-4" }, [
    _c(
      "div",
      { class: ["relative", "w-full", { "mb-3": !_vm.noMargin }] },
      [
        _vm.label !== ""
          ? _c(
              "label",
              {
                staticClass:
                  "block uppercase text-gray-600 text-xs font-bold mb-2 text-left"
              },
              [
                _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
                _vm.required
                  ? _c("span", { staticClass: "text-red-500" }, [_vm._v("*")])
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.info !== null
          ? [
              _c(
                "small",
                {
                  staticClass:
                    "text-gray-700 font-medium mb-2 text-left inline-block w-full"
                },
                [_vm._v(_vm._s(_vm.info))]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1752026d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1752026d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Form/FormItem.vue
// module id = null
// module chunks = 